/* eslint-disable global-require */
const axios = require('axios')

exports.listTransaction = async (uuid, start, end) => {
  const config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: `https://app.manyconvert.com/api/list-transaction/${uuid}?start_date=${start}&end_date=${end}`,
    headers: {
      'Content-Type': 'application/json',
    },
  }

  const resp = await axios.request(config)
    .then(response => response.data)
    .catch(error => {
      console.log(error)
    })

  console.log(resp)

  return resp
}
